import type { CampaignDraftCreatorItem, CampaignDraftPostItem } from '@/entities/campaign';
import { atom } from 'jotai';

import type { CampaignEditorSubmitPayload } from '../types';

export const defaultCampaignEditorCreatorItem = (): CampaignDraftCreatorItem => ({
  id: crypto.randomUUID(),
  platform: '',
  sourceValue: '',
});

export const defaultCampaignEditorPostItem = (): CampaignDraftPostItem => ({
  id: crypto.randomUUID(),
  postUrl: '',
});

export const campaignNameAtom = atom('');
export const hasEditedCampaignNameAtom = atom(false);
export const campaignStartDateAtom = atom<DateISOString>('' as DateISOString);
export const hasEndDateAtom = atom(false);
export const campaignEndDateAtom = atom<DateISOString | undefined>(undefined);
export const creatorItemsAtom = atom<CampaignDraftCreatorItem[]>([
  {
    id: 'campaign-editor-default-creator-row',
    platform: '',
    sourceValue: '',
  },
]);
export const creatorKeywordsAtom = atom<string[]>([]);
export const postItemsAtom = atom<CampaignDraftPostItem[]>([
  {
    id: 'campaign-editor-default-post-row',
    postUrl: '',
  },
]);

export const draftCreatorItemsAtom = atom((get) =>
  get(creatorItemsAtom).filter((item) => item.sourceValue.trim().length > 0),
);

export const draftPostItemsAtom = atom((get) =>
  get(postItemsAtom).filter((item) => item.postUrl.trim().length > 0),
);

export const trackedItemSummaryAtom = atom((get) => {
  const creatorItems = get(draftCreatorItemsAtom);
  const postItems = get(draftPostItemsAtom);
  const totalTrackedItems = creatorItems.length + postItems.length;

  return {
    hasCreators: creatorItems.length > 0,
    hasPostUrls: postItems.length > 0,
    totalTrackedItems,
  };
});

export const campaignEditorSubmitPayloadAtom = atom<CampaignEditorSubmitPayload>((get) => ({
  campaignEndDate: get(campaignEndDateAtom),
  campaignName: get(campaignNameAtom),
  campaignStartDate: get(campaignStartDateAtom),
  creatorItems: get(draftCreatorItemsAtom),
  creatorKeywords: get(creatorKeywordsAtom),
  hasEndDate: get(hasEndDateAtom),
  postItems: get(draftPostItemsAtom),
}));
